import { isEqual } from 'lodash';
import { useSelector } from 'react-redux';
import { getMarketplaceEntities } from '../ducks/marketplaceData.duck';
import { OwnListing, OwnListingWithImages } from '../types/sharetribe/listing';
import { ensureOwnListing } from '../util/data';
import { types as sdkTypes } from '../util/sdkLoader';

const { UUID } = sdkTypes;

export const useOwnListing = (listingId?: string) => {
  const listing = useSelector<any>((state) => {
    const listingUuid = listingId && new UUID(listingId);
    const listings = getMarketplaceEntities(state, [{ id: listingUuid, type: 'ownListing' }]);
    return listings.length === 1 ? listings[0] : null;
  }, isEqual) as Partial<OwnListing> | null;
  const currentListing: OwnListingWithImages = ensureOwnListing(listing || {});

  return currentListing;
};
